namespace Matrix.Data {
    export class SecurityMatchRulesetColumns {
        static columnsKey = 'Data.SecurityMatchRuleset';
    }
}
